import React from "react";

export const OFFICE = {
  surface: "#FFFFFF", surface2: "#F5F3EF", surface3: "#FAF8F5",
  ink: "#141210", ink2: "#3A3531", muted: "#5B554F",
  brand: "#D9501F", brandStrong: "#C8461A", brandTertiary: "#FDEEE7", border: "#E3DFD9",
};

export function OfficeCard({ children, className = "", style, ...rest }) {
  return (
    <div className={`rounded-2xl border p-6 ${className}`}
      style={{ background: OFFICE.surface, borderColor: OFFICE.border, ...style }}
      {...rest}>
      {children}
    </div>
  );
}

export function OfficeButton({ children, variant = "primary", className = "", ...props }) {
  const styles = {
    primary: { background: OFFICE.brand, color: "#fff", border: `1px solid ${OFFICE.brand}` },
    ghost: { background: "transparent", color: OFFICE.ink, border: `1px solid ${OFFICE.border}` },
    danger: { background: "transparent", color: "#C0341A", border: `1px solid #E7C4BB` },
  };
  return (
    <button {...props}
      className={`inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium transition-all duration-150 hover:opacity-90 disabled:opacity-50 ${className}`}
      style={styles[variant]}>
      {children}
    </button>
  );
}

export function OfficeField({ label, hint, children }) {
  return (
    <label className="block">
      <span className="block text-sm font-medium mb-1.5" style={{ color: OFFICE.ink2 }}>{label}</span>
      {children}
      {hint ? <span className="block text-xs mt-1" style={{ color: OFFICE.muted }}>{hint}</span> : null}
    </label>
  );
}

export function OfficeInput(props) {
  return (
    <input {...props}
      className={`w-full rounded-xl border px-4 py-2.5 outline-none transition-colors focus:border-[#D9501F] ${props.className || ""}`}
      style={{ background: OFFICE.surface, borderColor: OFFICE.border, color: OFFICE.ink }} />
  );
}

export function OfficeTextarea(props) {
  return (
    <textarea {...props}
      className={`w-full rounded-xl border px-4 py-3 outline-none transition-colors focus:border-[#D9501F] ${props.className || ""}`}
      style={{ background: OFFICE.surface, borderColor: OFFICE.border, color: OFFICE.ink }} />
  );
}

// Small footer label under each admin section telling where the client sees it.
export function VisibilityTag({ where }) {
  const team = where === "team";
  return (
    <div className="mt-4 inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs"
      style={{ background: team ? OFFICE.surface2 : OFFICE.brandTertiary, color: team ? OFFICE.muted : OFFICE.brandStrong }}>
      {team ? "Solo team" : `Il cliente lo vede in: ${where}`}
    </div>
  );
}

export function StatusPill({ status }) {
  const op = status === "OPERATIVA";
  return (
    <span className="rounded-full px-3 py-1 text-xs font-medium"
      style={{ background: op ? "#E6F2EA" : "#FBF1DC", color: op ? "#2E8B4F" : "#8A6516" }}>
      {op ? "Operativa" : "In collaudo"}
    </span>
  );
}
